














































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment, { Moment } from 'moment';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
@Component({
  components: {
    BulkSearchModal,
  },
})
export default class SeaFreightBookingPage extends Vue {
  /** 海运订舱单的状态列表 */
  private get statusList(): TypeBase.StatusEnumListItem[] {
    return this.$util.mergeCountDataToStatusEnum(this.foreignBookingOrderStatusEnum, this.statusCountList, {
      text: this.t('全部'),
      value: undefined,
      total: 0,
    });
  }
  protected userAgent: boolean = navigator.userAgent.includes('Firefox/56.0');
  /** 列表数据 */
  protected dataList: TypeSeaFreightBooking.ListItem[] = [];
  /** 表格列 */
  protected columns: TypeBase.TableColumn[] = [];
  /** 加载状态 */
  protected loadingStatus: boolean = false;
  /** 始发港口列表 */
  protected startPortList: TypeSeaFreightBooking.StartPortItem[] = [];
  /** 目的港口列表 */
  protected endPortList: TypeSeaFreightBooking.EndPortItem[] = [];
  /** 柜型 */
  protected cabinetTypeList: TypeSeaFreightBooking.ContainerItem[] = [];
  /** 选中的项 */
  protected selectedList: string[] = [];
  /** 时间 */
  protected datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition();
  /** 状态列表 */
  @enumData('ForeignBookingOrder/ForeignBookingOrderStatusEnum')
  protected foreignBookingOrderStatusEnum: TypeBase.EnumListItem[] = [];
  /** 搜索项 */
  protected searchData: TypeSeaFreightBooking.SearchData = this.initSearchData();
  /** 上一次请求参数 */
  protected lastParams: TypeSeaFreightBooking.SearchData = {} as TypeSeaFreightBooking.SearchData;
  /** 页码总数 */
  protected total: number | null = 0;
  /** 状态数据列表 */
  private statusCountList: TypeCommon.StatusCountItem[] = [];
  public updateSearchList(): void {
    this.queryBookingOrderList();
  }
  /** 列表勾选切换 */
  protected onSelectChange(selectedRowKeys: string[]): void {
    this.selectedList = selectedRowKeys;
  }
  /** 初始化列表列数据 */
  protected initColumn(): void {
    this.columns = [
      {
        title: this.t('海运订舱单号'),
        dataIndex: 'booking_order_code',
        name: 'booking_order_code',
        disabled: true,
        scopedSlots: { customRender: 'booking_order_code' },
      },
      {
        title: this.t('参考编码'),
        dataIndex: 'reference_number',
        name: 'reference_number',
        filterEmpty: true,
      },
      {
        title: this.t('状态'),
        dataIndex: 'order_status',
        name: 'order_status',
        scopedSlots: { customRender: 'order_status' },
        filterEmpty: true,
      },
      {
        title: this.t('始发港口'),
        dataIndex: 'start_port_code_text',
        name: 'start_port_code_text',
        checked: false,
        width: 220,
        filterEmpty: true,
      },
      {
        title: this.t('目的港口'),
        dataIndex: 'end_port_code_text',
        name: 'end_port_code_text',
        checked: false,
        width: 220,
        filterEmpty: true,
      },
      {
        title: this.t('柜型'),
        dataIndex: 'cabinet_type_text',
        name: 'cabinet_type_text',
        filterEmpty: true,
        width: 220,
        checked: false,
      },
      {
        title: this.t('海柜号'),
        dataIndex: 'container_number',
        name: 'container_number',
        width: 240,
        filterEmpty: true,
        isCopy: true,
        checked: false,
      },
      {
        title: this.t('时间'),
        dataIndex: 'create_time',
        name: 'create_time',
        width: 220,
        scopedSlots: { customRender: 'create_time' },
      },
      {
        title: this.t('创建人'),
        dataIndex: 'create_user_name',
        name: 'create_user_name',
        filterEmpty: true,
        checked: false,
      },
      {
        title: this.t('操作'),
        name: 'operation',
        showColumnSetting: true,
        scopedSlots: { customRender: 'operation' },
        width: 190,
      },
    ];
  }
  protected created(): void {
    this.initColumn();
    this.queryBookingOrderList();
    this.queryStartPortList();
    this.queryEndPortList();
    this.queryCabinetTypeList();
  }
  /** 监听时间变化 */
  @Watch('datetimeDefaultValue', { immediate: true })
  protected onDatetimeDefaultValueChange(arr: Moment[]): void {
    let start_time: string = '';
    let end_time: string = '';
    if (arr.length) {
      start_time = this.$util.formatDateTime(arr[0]);
      end_time = this.$util.formatDateTime(arr[1]);
    } else {
      start_time = '';
      end_time = '';
    }
    this.searchData.time_list = [{
      start_time: start_time,
      end_time: end_time,
      type: this.searchData.date_type ? this.searchData.date_type : this.$enum.seaFreightBooking.TimeType.CREATION
    }];
  }
  /**
   * 设置搜索参数（接口入参格式为数组）
   */
  protected setSearchData(): TypeSeaFreightBooking.SearchData {
    const searchData = this.$util.deepCopy(this.searchData);
    // 海运订舱单号 和 海柜号
    searchData.booking_order_list = [];
    searchData.container_number_list = [];
    const codeValue = searchData.code_value;
    if (!!codeValue) {
      switch (searchData.code_type) {
        case this.$enum.seaFreightBooking.CodeType.BOOKING_ORDER_CODE:
          searchData.booking_order_list = codeValue.split(',');
          break;
        case this.$enum.seaFreightBooking.CodeType.CONTAINER_NUMBER:
          searchData.container_number_list = codeValue.split(',');
          break;
        case this.$enum.seaFreightBooking.CodeType.REFERENCE_NUMBER:
          searchData.reference_number_list = codeValue.split(',');
          break;
      }
    }
    // 始发港口
    searchData.start_port_list = !!searchData.start_port ? [searchData.start_port] : [];
    // 目的港口
    searchData.end_port_list = !!searchData.end_port ? [searchData.end_port] : [];
    // 柜型
    searchData.cabinet_type_list = !!searchData.cabinet_type ? [searchData.cabinet_type] : [];
    // 时间类型
    searchData.time_list[0].type = !!searchData.date_type ? searchData.date_type : this.$enum.seaFreightBooking.TimeType.CREATION;
    delete searchData.code_type;
    delete searchData.code_value;
    delete searchData.start_port;
    delete searchData.end_port;
    delete searchData.cabinet_type;
    delete searchData.date_type;
    return searchData;
  }
  /**
   * 海运订舱单列表
   */
  @loading('loadingStatus')
  protected async queryBookingOrderList(): Promise<void> {
    const searchData = this.setSearchData();
    this.lastParams = this.$util.deepCopy(searchData);
    this.total = null;
    this.queryBookingOrderStatusCount();
    const { data } = await this.$api.seaFreightBooking.queryBookingOrderList<TypeSeaFreightBooking.ListResult>(searchData);
    const { list, total } = data;
    this.dataList = list;
    this.total = total;
  }
  /**
   * 海运订舱单状态数量
   */
  protected async queryBookingOrderStatusCount(): Promise<void> {
    const searchData = this.setSearchData();
    const { data } = await this.$api.seaFreightBooking.queryBookingOrderStatusCount<TypeSeaFreightBooking.StatusCountItem[]>(searchData);
    const StatusCounts: TypeCommon.StatusCountItem[] = (data || []).map((item: TypeSeaFreightBooking.StatusCountItem) => {
      return {
        status: item.order_status,
        count: item.order_count
      }
    });
    const total: number = (StatusCounts || []).reduce((pre: number, item: TypeCommon.StatusCountItem) => {
      return pre + item.count;
    }, 0);
    StatusCounts.unshift({
      status: undefined,
      count: total,
    });
    this.statusCountList = StatusCounts;
  }
  /** 始发港口 */
  protected async queryStartPortList(): Promise<void> {
    const { data } = await this.$api.seaFreightBooking.queryStartPortList<TypeSeaFreightBooking.StartPortItem[]>({ status: this.$enum.common.Enabled.YES });
    this.startPortList = data || [];
  }
  /** 目的港口 */
  protected async queryEndPortList(): Promise<void> {
    const { data } = await this.$api.seaFreightBooking.queryEndPortList<TypeSeaFreightBooking.EndPortItem[]>({ status: this.$enum.common.Enabled.YES });
    this.endPortList = data || [];
  }
  /** 柜型 */
  protected async queryCabinetTypeList(): Promise<void> {
    const { data } = await this.$api.seaFreightBooking.queryContainerList<TypeSeaFreightBooking.ContainerItem[]>({ status: this.$enum.common.Enabled.YES });
    this.cabinetTypeList = data || [];
  }
  /** 页码变动 */
  protected handlePageChange(val: number): void {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryBookingOrderList();
  }
  /** 点击每个tab的回调 */
  protected handleTabChange(key: string): void {
    this.initPage();
    this.queryBookingOrderList();
  }
  @userPrefPageSize('seaFreightBooking')
  protected initSearchData(): TypeSeaFreightBooking.SearchData {
    return {
      /** 海运订舱单状态(1:草稿,2待审核,3:待确认,4:已完结,5:审核驳回,6:已废弃)  */
      order_status: undefined,
      code_type: this.$enum.seaFreightBooking.CodeType.BOOKING_ORDER_CODE,
      code_value: '',
      /** 海运订舱单号列表（最大200）  */
      booking_order_list: [],
      /** 海柜号  */
      container_number_list: [],
      /** 参考编码列表（最大200）  */
      reference_number_list: [],
      /** 始发港（最大200）  */
      start_port_list: [],
      start_port: undefined,
      /** 目的港（最大200）  */
      end_port_list: [],
      end_port: undefined,
      /** 柜型  */
      cabinet_type_list: [],
      cabinet_type: undefined,
      /** 时间范围  */
      time_list: [],
      date_type: this.$enum.seaFreightBooking.TimeType.CREATION,
      page_index: 1,
      page_size: 10,
    };
  }
  // 重置页面数据
  protected initPage(): void {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  }
  // 搜索按钮
  protected handleSearch(): void {
    this.initPage();
    this.queryBookingOrderList();
  }
  // 清空
  protected handleReset(): void {
    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(() => this.queryBookingOrderList());
  }
  /**
   * 双击批量查询
   */
  protected handleDblClick(): void {
    const bulkSearchRef = this.$refs.bulkSearchModal as any;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.searchData.code_value;
  }
  /**
   * 获取批量搜索条件值
   */
  protected handleBulkFeedback(bulkKeywords: string): void {
    this.searchData.code_value = bulkKeywords;
  }
  /**
   * 导出
   */
  protected async handleExport(isAll: boolean): Promise<void> {
    let postData: TypeSeaFreightBooking.ExportSearchData = {} as TypeSeaFreightBooking.ExportSearchData;
    if (isAll) {
      postData = { ...this.lastParams } as TypeSeaFreightBooking.ExportSearchData;
      delete postData.page_index;
      delete postData.page_size;
      postData.booking_order_list = [];
    } else {
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.booking_order_list = this.selectedList;
    }
    const { code, data, message } = await this.$api.seaFreightBooking.exportBookingOrder<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }
  /**
   * 新增
   */
  protected handleAdd(): void {
    this.$router.push({
      name: 'AddSeaFreightBookingPage',
      params: {
        noCache: '1',
      },
    });
  }
  /**
   * 编辑
   */
  protected handleEdit(code: string): void {
    this.$router.push({
      name: 'EditSeaFreightBookingPage',
      query: { code },
      params: {
        noCache: '1',
      },
    });
  }
  /**
   * 复制
   */
  protected handleCopy(code: string): void {
    this.$router.push({
      name: 'CopySeaFreightBookingPage',
      query: { code },
      params: {
        noCache: '1',
      },
    });
  }
  /** 提交前，校验海柜号 */
  protected containerNumberValidator(row: TypeSeaFreightBooking.ListItem): boolean {
    if (!row.container_number || !/^[a-zA-Z0-9_\-]{0,35}$/.test(row.container_number)) {
      this.$message.warn('海柜号不能为空，且最大长度为35位，由数字、字母、下划线、中划线组成，请重新编辑');
      return false;
    }
    return true;
  }
  /** 提交（单个） */
  protected handleSubmitBooking(row: TypeSeaFreightBooking.ListItem): void {
    if (!this.containerNumberValidator(row)) {
      return;
    }
    this.$confirm({
      title: this.tc('提交'),
      content: this.t('请确认是否提交该海运订舱单？'),
      onOk: () => {
        this.submitBookingOrder([row.booking_order_code]);
      },
    });
  }
  /** 提交（批量） */
  protected handleSubmitBookingBulk(): void {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择需要提交的单据'));
      return;
    }
    this.$confirm({
      title: this.tc('提交'),
      content: this.t('请确认是否提交已选中海运订舱单？'),
      onOk: () => {
        this.submitBookingOrder(this.selectedList);
      },
    });
  }
  /**
   * 提交海运订舱单
   */
  private async submitBookingOrder(selectedList: string[]): Promise<void> {
    const h = this.$createElement;
    const { data } = await this.$api.seaFreightBooking.submitBookingOrder<TypeSeaFreightBooking.SubmitBookingOrderRes>({ booking_order_list: selectedList });
    if (data && data.errors && data.errors.length > 0) {
      const modal = this.$error({
        title: this.tc('提交失败'),
        icon: 'close-circle',
        width: 640,
        content: () => {
          return <div class="error-message-box">{
            data.errors.map((item) => {
              return <div class={'message-row'}>
                <div class="code" onclick={() => {
                  this.handleEdit(item.booking_order_code);
                  modal.destroy();
                }
                }>{item.booking_order_code}：</div>
                <div class="message">{item.error_message}，{this.t('请重新编辑')}</div>
              </div>
            })
          }</div>
        },
        onOk: () => {
          modal.destroy();
        },
      });
    } else {
      this.$message.success(this.t('提交成功'));
      this.handleSearch();
    }
  }
  /**
   * 废弃（单个）
   */
  private handleDiscard(code: string): void {
    this.$confirm({
      title: this.tc('废弃'),
      content: this.t('请确认是否废弃该海运订舱单？'),
      onOk: () => {
        this.discardBookingOrder([code]);
      },
    });
  }
  /**
   * 废弃（批量）
   */
  private handleDiscardBulk(): void {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择需要废弃的单据'));
      return;
    }
    this.$confirm({
      title: this.tc('废弃'),
      content: this.t('请确认是否废弃已选中海运订舱单？'),
      onOk: () => {
        this.discardBookingOrder(this.selectedList);
      },
    });
  }
  /**
   * 废弃海运订舱单
   */
  private async discardBookingOrder(selectedList: string[]): Promise<void> {
    const res = await this.$api.seaFreightBooking.discardBookingOrder({ booking_order_list: selectedList });
    this.$message.success(this.t('废弃成功'));
    this.handleSearch();
  }
}
